const indexFieldKeys = {
  all: ['indexFields'],
  distinctValues: (indexFieldId) => [indexFieldKeys.all, indexFieldId]
};

export default indexFieldKeys;
